import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowLeft, FiCheckCircle, FiMail } from 'react-icons/fi';
import { api } from '../services/api';
import { useLocale } from '../context/LocaleContext';
import { resolveSettingMediaUrl, useSiteSettings } from '../context/SiteSettingsContext';
import './Auth.css';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { settings } = useSiteSettings();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setSubmitting(true);
    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      setSuccess(response.message);
    } catch (err) {
      setError(err.data?.message || err.message || t('auth.forgotFailed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-v2-page">
      <section className="auth-v2-shell">
        <div className="auth-v2-card auth-v2-card-compact">
            <Link className="auth-v2-brand" to={localePath('/')}><img src={resolveSettingMediaUrl(settings.general.logoUrl) || '/logo/logo-login.webp'} alt={settings.general.siteTitle} /></Link>
            <header className="auth-v2-heading"><h2>{t('auth.forgotTitle')}</h2><p>{t('auth.forgotHint')}</p></header>
            {error && <div className="auth-v2-alert is-error" role="alert">{error}</div>}
            {success && <div className="auth-v2-alert is-success" role="status"><FiCheckCircle /> {success}</div>}
            {!success && (
              <form onSubmit={handleSubmit} className="auth-v2-form">
                <label className="auth-v2-field" htmlFor="email"><span>{t('auth.accountEmail')}</span><div><FiMail />
                  <input type="email" id="email" value={email} onChange={(event) => { setEmail(event.target.value); setError(''); }} placeholder="example@email.com" autoComplete="email" required />
                </div></label>
                <button type="submit" className="auth-v2-submit" disabled={submitting}>{submitting ? t('auth.sending') : t('auth.sendReset')}</button>
              </form>
            )}
            <footer className="auth-v2-footer"><p>{t('auth.remembered')} <Link to={localePath('/login')}>{t('auth.signIn')}</Link></p></footer>
            <Link className="auth-v2-back" to={localePath('/login')}><FiArrowLeft /> {t('auth.backLogin')}</Link>
        </div>
      </section>
    </main>
  );
};

export default ForgotPassword;
